import { Trans } from "@lingui/react/macro";
import { Container, Link as MuiLink, Stack, Typography } from "@mui/material";
import AppLayout from "@/components/AppLayout";

export default function Imprint() {
  return (
    <AppLayout contentMaxWidth="md">
      <Container maxWidth="md" sx={{ py: { xs: 3, md: 4 }, px: { xs: 2, md: 3 } }}>
        <Typography variant="h2" gutterBottom sx={{ mb: 3 }}>
          <Trans>Legal Notice</Trans>
        </Typography>
        <Stack spacing={1.5}>
          <Typography variant="h3">
            <Trans>Information according to § 5 TMG</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              CampNerd GmbH & Co. KG
              <br />
              Spandauer Burgwall 22A
              <br />
              13581 Berlin
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              Commercial register: HRA 60637
              <br />
              Register Court: Berlin Local Court (Charlottenburg)
            </Trans>
          </Typography>
          <Typography variant="h3">
            <Trans>Represented by:</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              CampNerd Verwaltungs GmbH
              <br />
              Spandauer Burgwall 22
              <br />
              13581 Berlin
            </Trans>
          </Typography>
          <Typography variant="h3">
            <Trans>Represented by:</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>Christian Günther</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              Commercial register: HRB 245650
              <br />
              Register Court: Berlin Local Court (Charlottenburg)
            </Trans>
          </Typography>
          <Typography variant="h3">
            <Trans>Contact</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              Tel: 030 - 343 885 80
              <br />
              E-Mail: <MuiLink href="mailto:office@campnerd.camp">office@campnerd.camp</MuiLink>
              <br />
              Web:{" "}
              <MuiLink href="https://www.campnerd.camp/" target="_blank">
                www.campnerd.camp
              </MuiLink>
            </Trans>
          </Typography>
          <Typography variant="h3">
            <Trans>Sales tax ID</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              Sales tax identification number according to § 27a Umsatzsteuergesetz:
              <br />
              DE356327282
            </Trans>
          </Typography>
          <Typography variant="h3">
            <Trans>EU Dispute Resolution</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              The European Commission provides a platform for online dispute resolution (OS):{" "}
              <MuiLink
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noreferrer noopener"
              >
                https://ec.europa.eu/consumers/odr/
              </MuiLink>
              .<br />
              You can find our e-mail address above.
            </Trans>
          </Typography>
          <Typography variant="h3">
            <Trans>Consumer dispute resolution/universal dispute resolution body</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              We are not willing or obliged to participate in dispute resolution proceedings before
              a consumer arbitration board.
            </Trans>
          </Typography>
        </Stack>
      </Container>
    </AppLayout>
  );
}
